import type { RouteRecordRaw } from "vue-router";
import type { MenuRoute } from "@/shared/types/route";
import { uiLibraryComponents } from "@/pages/dev/ui-library/catalog";
import {
  DEVELOP_PATH,
  DEV_CLODOP_TEMPLATE_PATH,
  DEV_PLATFORM_PRINT_PATH,
  DEV_PRINT_DESIGNER_PATH,
  DEV_UI_LIBRARY_PATH,
} from "../constants";

const layoutComponent = () => import("@/widgets/app-shell/AppShell.vue");

export const developMenuRoutes: MenuRoute[] = import.meta.env.DEV
  ? [
      {
        path: DEVELOP_PATH,
        name: "Develop",
        title: "开发调试",
        icon: "code",
        redirect: DEV_CLODOP_TEMPLATE_PATH,
        children: [
          {
            path: DEV_CLODOP_TEMPLATE_PATH,
            name: "DevelopCLodopTemplateDebug",
            title: "C-Lodop 模板调试",
            icon: "file-text",
          },
          {
            path: DEV_PRINT_DESIGNER_PATH,
            name: "DevelopPrintDesignerDebug",
            title: "打印设计器调试",
            icon: "printer",
          },
          {
            path: DEV_PLATFORM_PRINT_PATH,
            name: "DevelopPlatformPrintDebug",
            title: "平台面单打印调试",
            icon: "printer",
          },
        ],
      },
    ]
  : [];

export const publicDevelopRoutes: RouteRecordRaw[] = import.meta.env.DEV
  ? [
      {
        path: DEV_UI_LIBRARY_PATH,
        name: "DevUiLibrary",
        redirect: `${DEV_UI_LIBRARY_PATH}/select`,
        meta: {
          title: "UI 组件库",
          public: true,
        },
      },
      ...uiLibraryComponents.map<RouteRecordRaw>((component) => ({
        path: `${DEV_UI_LIBRARY_PATH}/${component.slug}`,
        name: `DevUiLibrary${component.value}`,
        component: () => import("@/pages/dev/ui-library/index.vue"),
        props: {
          componentKey: component.value,
        },
        meta: {
          title: `${component.label} - UI 组件库`,
          public: true,
        },
      })),
      {
        path: DEVELOP_PATH,
        name: "Develop",
        component: layoutComponent,
        redirect: DEV_CLODOP_TEMPLATE_PATH,
        meta: {
          title: "开发调试",
          public: true,
        },
        children: [
          {
            path: "clodop-template",
            name: "DevelopCLodopTemplateDebug",
            component: () => import("@/pages/dev/clodop-template/index.vue"),
            meta: {
              title: "C-Lodop 模板调试",
              public: true,
            },
          },
          {
            path: "print-designer-debug",
            name: "DevelopPrintDesignerDebug",
            component: () => import("@/pages/dev/print-designer-debug/index.vue"),
            meta: {
              title: "打印设计器调试",
              public: true,
            },
          },
          {
            path: "platform-print-debug",
            name: "DevelopPlatformPrintDebug",
            component: () => import("@/pages/dev/platform-print-debug/index.vue"),
            meta: {
              title: "平台面单打印调试",
              public: true,
            },
          },
        ],
      },
    ]
  : [];
